import { Poll } from '../cms-components/blackrock/advisor-center/poll/Poll';

export const PollComponent = Poll;
